__turbopack_context__.v({
  "container": "SlideshowBlock-module__L4wsuq__container",
  "fadeInItems": "SlideshowBlock-module__L4wsuq__fadeInItems",
  "image": "SlideshowBlock-module__L4wsuq__image",
  "spacing--lg": "SlideshowBlock-module__L4wsuq__spacing--lg",
  "spacing--md": "SlideshowBlock-module__L4wsuq__spacing--md",
  "spacing--sm": "SlideshowBlock-module__L4wsuq__spacing--sm",
  "spacing--xl": "SlideshowBlock-module__L4wsuq__spacing--xl",
  "spacing--xs": "SlideshowBlock-module__L4wsuq__spacing--xs",
  "spacing--xxl": "SlideshowBlock-module__L4wsuq__spacing--xxl",
  "spacing--xxs": "SlideshowBlock-module__L4wsuq__spacing--xxs",
  "spacing--xxxl": "SlideshowBlock-module__L4wsuq__spacing--xxxl",
  "spacing--xxxs": "SlideshowBlock-module__L4wsuq__spacing--xxxs",
});
